var TemplateDescription = (function () {
    function TemplateDescription() {
    }
    TemplateDescription.prototype.run = function (fc) {
        fc.templateManipulators.postWrapper.push(function (field) {
            if (field && field.templateOptions && field.templateOptions.description) {
                return 'description';
            }
        });
    };
    return TemplateDescription;
}());
export { TemplateDescription };
//# sourceMappingURL=description.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng-formly/lib/src/ui-bootstrap/src/run/description.js
// module id = 770
// module chunks = 3